module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-4.db21572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-4.jpg
// module id = NSAR
// module chunks = 1